import './util-activity-type.scss';

import { Outlet } from "react-router-dom";

import { FilterUtilActivityTypeProvider } from "./filter-util-activity-type/filter-util-activity-type.context";

export function UtilActivityType() {
  return (
    <div id="ShellUtilActivityType" className="util-activity-type">
       <FilterUtilActivityTypeProvider>
        <Outlet />
      </FilterUtilActivityTypeProvider>
    </div>
  );
}

export default UtilActivityType;
